import { defineStore } from "pinia";
import { RemovableRef, useLocalStorage } from "@vueuse/core";
import { ref } from "vue";
import {
  getTranslateEnumByLocale,
  TranslationLanguageEnum,
} from "@/enums/translateEnums";

export const useTranslate = defineStore("translate", () => {
  const showLangSelection = ref(false);
  const targetLang = useLocalStorage(
    "translateTargetLang",
    getTranslateEnumByLocale(
      navigator.language.toLowerCase().split("-")[0] ?? "en"
    )
  ) as RemovableRef<TranslationLanguageEnum>;
  return {
    /**
     * 控制TranslateLangSelectionPopup的显示
     * @see TranslateLangSelectionPopup.vue
     */
    showLangSelection,
    /** 翻译目标语言枚举 */
    targetLang,
  };
});
